import React from 'react';
import FieldObject from './field_object';
import { withLocalePrefix } from 'shared/utils/translation';
import { SimpleSingleDropdown } from '@grnhse/seedling/lib/birch/components/forms/dropdown';
import type { Item } from '@grnhse/seedling/lib/birch/components/forms/dropdown/item';

const t = withLocalePrefix('talent_search.form.sections.candidate.labels');

type Props = {
  fieldObject: FieldObject;
  onUpdate: (val: FieldObject) => void;
};

const YesNoOption = ({ fieldObject, onUpdate }: Props) => {
  const value = fieldObject.selection as Item | null;

  const options = [
    { value: '1', label: 'Yes' },
    { value: '2', label: 'No' },
  ];

  const onSelection = (newValue: Item | null) => {
    fieldObject.setSelection(newValue);
    onUpdate(fieldObject);
  };

  return (
    <SimpleSingleDropdown
      data-provides="talent-search-yes-no-dropdown"
      items={options}
      selectedItem={value}
      onSelectedItemChange={onSelection}
      label={t('yes_no')}
      clearable={false}
    />
  );
};

export default YesNoOption;
